<!-- 培训详情 -->
<template>
    <div class="page-form">
        <PageBack :title="title" />
        <div class="detail-wrap" v-if="ready">                
            <el-row >
                <el-col class="pub-title">{{ dataList.title }} </el-col>
            </el-row>
            <el-row class="mg-t-20">
                <el-col>
                    <span class="sub-title">主办单位</span>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ dataList.host }}</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20">
                <el-col><span class="sub-title">承办单位</span></el-col>
                <el-col>
                    <div class="sub-name">{{ dataList.underTake }}</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-10">
                <el-col><span class="sub-title">协办单位</span></el-col>
                <el-col>
                    <div class="sub-name">{{ organizerData }}</div>
                </el-col>
            </el-row>
            <el-row class="mg-t-20">
                <el-col>
                    <span class="sub-title">培训费用</span>
                </el-col>
                <el-col>
                    <div class="sub-name">{{ dataList.fee }}元</div>
                </el-col>
            </el-row>           
            <el-row class="mg-t-20">
                <el-col><span class="sub-title">培训详情</span></el-col>
                <el-table border :data="tableData" style="width: 100%;">      
                    <el-table-column  prop="city"  label="培训城市"  width="80"/>      
                    <el-table-column  prop="eventDate"  label="培训开始日期" width="120" />
                    <el-table-column  prop="eventEndDate"  label="培训结束日期" width="120" />
                    <el-table-column  prop="eventTime"    label="培训时间" width="140"/>
                    <el-table-column  prop="address"  label="详细地址"/>           
                </el-table> 
            </el-row>
            <el-row class="mg-t-20">
                <div v-if="tableData.length > 0">
                    <span class="sub-title">培训讲师</span>
                    <el-tabs type="border-card" v-model="trainId"  @tab-click="selectLucturer">
                        <el-tab-pane :label="item.city" :name="item.serial"
                        v-for="(item) in tableData" :key="item.city">
                        <div class="lecture-content" v-for="item in lecturerData" :key="item.username">
                            <div>讲师姓名： {{ item. username}}</div>
                            <div>讲师描述： {{ item. des}}</div>
                            <div v-if="item.imageUrl">
                                <el-image :src="item.imageUrl"  class="lecturer-img"></el-image>
                            </div>                            
                        </div> 
                        </el-tab-pane>
                    </el-tabs>                    
                </div>
            </el-row>
            <el-row class="mg-t-20">
                <el-col><span class="sub-title">培训内容</span></el-col>
                <el-col>
                    <div class="sub-name">{{ dataList.content }}</div>
                </el-col>
                <div v-if="dataList.image1 !==''">
                    <el-image :src="dataList.image1" style="width:360px"></el-image>
                </div>
            </el-row>                  
            <el-row class="mg-t-20">
                <el-col>
                    <span class="sub-title">培训须知</span>                                  
                </el-col>  
                <el-col class="wrap-line">
                    {{ dataList.notice }}
                </el-col>    
                <div v-if="dataList.image2 !==''">
                    <el-image :src="dataList.image2" style="width:360px"></el-image>
                </div>          
            </el-row> 
            <el-row class="mg-t-20">
                <el-col>
                    <span class="sub-title">学员权益</span>                
                </el-col>
                <el-col class="wrap-line">
                    {{ dataList.equity }}
                </el-col>
                <div v-if="dataList.image3 !==''">
                    <el-image :src="dataList.image3" style="width:360px"></el-image>
                </div>
            </el-row>
            <el-row class="mg-t-20">
                <el-col>
                    <span class="sub-title">课堂纪律</span>
                </el-col>
                <el-col class="mg-t-20 wrap-line">{{ dataList.discipline }}</el-col>
            </el-row>    
            <el-row class="mg-t-20">
                <el-col>
                    <span class="sub-title">自愿参培承诺书</span>                                       
                </el-col>
                <el-col class="wrap-line">
                    {{ dataList.letter }}                        
                </el-col>
            </el-row>            
        </div>
    </div>
</template>

<script>

import PageBack from '@/components/PageHeader'
import Qrcode from '@/components/Qrcode'
export default {
    components: {
        PageBack,
        Qrcode
    },
    data() {
        return {
            show: false,
            ready: false,
            dataList: {},
            detailList:{},
            publishId: '',
            clientWidth: '',
            applyUrl: '',
            hostData: '',
            underTakeData: '',
            lecturerData:'',
            organizerData: '',
            publishUrl: window.location.href, //window.location.href
            url: 'http://www.guanyb.cn/#/publishQuery?id=',
            disabled:false,
            tableData: [],
            trainId: '1',
            image1: '',
            image2: '',
            image3: ''
        }
    },
    created() {
        // window.addEventListener('resize', this.handleResize); 

        this.publishId = this.$route.query.id
       
        this.ready = true
        if(this.ready){            
            this.getOrganizer()
        }
    },
    watch:{      
    //   clientWidth(){             
    //     if(this.clientWidth > 768){
    //       this.show = true
    //     }else{
    //       this.show = false
    //     }        
    //   }
    },
    computed: {
        title() {
            return this.$route.meta.title
        },
    },
    mounted() {
        this.initData()        
        // this.publishUrl = this.url + this.publishId
        this.trainDetailData()
    },
    methods: {
        initData(){
            let params = {
                    opcode: this.$code.TrainQuery,
                    i_serial_train: this.publishId,
                    v_train_title: '',
                    c_status: '',
                    start_date: '',
                    end_date: '',
                    pagesize: 10,
                    page: 1,
                }
                this.loading = true
                this.$api.requestAPI(params).then(res =>{
                    if (res.IsSuccess) {
                    let result = res.Data.DataTable                  
                    let list = result.map(item=>{ 
                         return{
                            title: item['培训主题'],
                            content: item['培训内容'],
                            fee: item['培训费用'],
                            equity: item['学员权益'],
                            underTake: item['承办单位名称'],
                            host: item['主办单位名称'],
                            notice: item['报名须知'],
                            discipline: item['课堂纪律'],
                            letter: item['自愿参培承诺书'],
                            username: item['发布人'],
                            userId: item['发布人账号'],
                            serialTrain: item['培训标识'],
                            status: item['培训状态'],
                            image1: item['图片1'],
                            image2: item['图片2'],
                            image3: item['图片3'],
                         }   
                    })
                    // console.log(list)
                    this.dataList = list[0]
                }else{

                }        
            })
        },
        trainDetailData(){
            let params = {
                opcode: this.$code.TrainDetailQuery,
                i_serial_train: this.publishId,
                id: '',
                c_status: '',
                start_date: '',
                end_date: '',
                v_economize: '',
                v_city: '',
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    if(result.length >0){
                        let list = result.map(item=>{
                        let eventDate = this.$help.formatDate(item['开始日期'])
                        let eventEndDate = this.$help.formatDate(item['结束日期'])
                        let startTime = this.$help.formatTime(item['开始时间'])
                        let endTime = this.$help.formatTime(item['结束时间'])
                        return{
                            serial: item['序号'].toString(),
                            title: item['培训标题'],
                            amount: item['人数'],
                            address: item['具体地点'],
                            signTime: item['签到结束区间'],
                            serialRemark: item['培训标识'],
                            applyNumber: item['报名人数'],
                            provinces:item['省'],
                            city: item['市'],
                            eventDate: eventDate,
                            eventEndDate: eventEndDate,
                            eventTime:  startTime + '~' + endTime,
                            status: item['培训状态'],
                        }
                    })     
          
                    this.tableData = list
                    this.trainId = list[0].serial

                        if(this.trainId !==''){
                            this.getLecturer()
                        }
                    }                    
                }else{
                    this.tableData = []
                }
            })
        },
        copyApplyLink(url){
            var input = document.createElement("input"); // 创建input对象
            input.value = url; // 设置复制内容
            document.body.appendChild(input); // 添加临时实例
            input.select(); // 选择实例内容
            document.execCommand("Copy"); // 执行复制
            document.body.removeChild(input); // 删除临时实例
            this.$message.success('复制链接成功：'+ input.value)
        },
        // handleResize(){
        //     this.clientWidth = window.innerWidth || document.body.clientWidth;
        // },
        selectLucturer(tab){
            this.trainId = tab.name
            if(this.trainId){
                this.getLecturer()
            }
            
        },
        // 查询讲师
        getLecturer(){
            let params = {
                opcode:this.$code.TeacherQuery,                
                i_serial_train: this.publishId,
                id:  this.trainId,
                i_lecturer_no: '',
                v_lecturer_name: ''
            };
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){                 
                    if(res.Data.SumCount > 0){                        
                        let result = res.Data.DataTable;                      
                        this.lecturerData = result.map(item=>{
                            return{
                                username: item['培训讲师名称'],
                                des: item['培训讲师描述'],
                                userId: item['培训讲师账号'],
                                imageUrl: item['图片']
                            }
                        })
                    }else{
                        this.lecturerData = []
                    }
                }
            }).catch(error =>{
                console.log(error);
            })
        },
        // 查询协办
        getOrganizer(){
            let params = {
                opcode:this.$code.TrainOrganizer,
                i_serial_train: this.publishId,
                i_organizer_no: '',
                v_organizer_name: '',
            };
            this.$api._requestAPI(params).then(res =>{
                if(res.IsSuccess){                 
                    if(res.Data.SumCount > 0){                        
                        let result = res.Data.DataTable;
                        this.organizerData = result.map(item => item['协办单位名称']).join(`\n`)
                    }else{
                        this.organizerData = ''
                    }
                }
            }).catch(error =>{
                console.log(error);
            })
        }
    },
    destroyed(){
    //   window.removeEventListener('resize', this.handleResize);
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
.bread{
    margin: 30px 0 0 215px;
  }
.pub-title{
    font-size: 20px;
    padding-bottom: 20px;
    text-align: center;
    white-space: pre-line;
}
.detail-wrap{
    width: 1000px;
    line-height: 28px;
}
.sub-title{
    padding: 4px 15px;
    font-size: 16px;
    color: #fff;
    background-color: #e62e02;
    border-radius: 5px;
}
.sub-name{
    padding: 15px;
    font-size: 16px;
    white-space: pre-line;
}
.mg-l-20{
    margin-left: 20px;
}
.wrap-line{
    white-space: pre-line;
    font-size: 16px
}
.qrcode{
    display: flex;
    margin-top: 15px;
}
.lecture-content{
    padding: 15px;
    font-size: 16px;
    white-space: pre-wrap;
    border: 1px solid #e1e1e1;
}
.lecturer-img{
    width: 200px;
    border-radius: 50%;
}
</style>


// WEBPACK FOOTER //
// src/views/training/TrainDetail.vue